/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Filter Drawer Closed Icon component.
 */
export const FilterDrawerClosedIcon = ({
  color = dlsColor('grey2')
}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({color});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path fillRule='evenodd'
        clipRule='evenodd'
        d='M9.92574 6.66669L8.68994 7.91113L12.7504 12L8.68994 16.0889L9.92574 17.3334L15.222 12L9.92574 6.66669Z'
        fill={iconColor} />
    </svg>
  );
};

export default FilterDrawerClosedIcon;
